import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Container, Row, Col, Card, CardHeader, CardBody } from "reactstrap";
import SwitchVersion from '../../../Components/SwitchVersion';
import SettingsButton from '../../../Components/Buttons/SettingsButton';
import NewVersionBtn from '../../../Components/Buttons/NewVersionBtn';
import DuplicateVersionBtn from '../../../Components/Buttons/DuplicateVersionBtn';
import NewCreativeBtn from '../../../Components/Buttons/NewCreativeBtn';
import PublishBtn from '../../../Components/Buttons/PublishBtn';
import FeedBindBtn from '../../../Components/Buttons/FeedBindBtn';
import StatusBadge from '../../../Components/StatusBadge';
import CommentBtn from '../../../Components/Buttons/CommentBtn';
import ShowcaseBtn from '../../../Components/Buttons/ShowcaseBtn';
import ApproveAllBtn from '../../../Components/Buttons/ApproveAllBtn';
import Filters from '../../../Components/Buttons/Filters';
import { setVersionPath } from '../../../../../../slices/auth/menu/reducer';
import { openCampaign, getCreatives, getDynamicText, setAllCreativesDynamicText, setCreativeFigmaBeforePreview, setHtmlCreativesPreview, getFontList, setPreviewFonts, createPreview, updateVersionStatusAfterUpdate } from '../../../../../../slices/campaigns/thunk';
import { setActiveDynamicText, setCampaignLoader, setConnectedFeed, setCreatives, setCreativesFirstLoad, setCreativesHasMore, setCreativesLoading, setCreativesPage, setCurrentVersion, setFilteredCreatives, setScrolledCreatives, setTemplateLoader, setVersionDetails, updateCreatives, updateScrolledCreatives } from '../../../../../../slices/campaigns/reducer';
import { calculateCreativesPerPage, createLinkForDynamicTextFont } from '../../../../../../slices/campaigns/helper';
import BannerCard from '../../../Components/BannerCard';
import DynamicEditArea from './DynamicEditArea';
import DuplicateSetModal from '../../../Components/Modals/DuplicateSetModal';
import SettingsModal from '../../../Components/Modals/SettingsModal';
import AddNewTemplateCreative from './AddNewTemplateCreative';
// import AddNewVersion from './AddNewVersion';
import FilterModal from '../../../Components/Modals/FilterModal';
import Comment from '../../../Components/Modals/CommentsModal';
import FallbackImageModal from './FallbackImageModal';
import ShowcaseModal from '../../../Components/Modals/ShowcaseModal';
import FeedConnection from '../Modals/Feed/FeedConnection';
import ConvertedTemplate from './ConvertedTemplate';
import SelectTemplateModal from '../EmptyPage/SelectTemplateModal';
import AddNewTemplateVersion from './AddNewTemplateVersion';
import { setPreloader } from '../../../../../../slices/layouts/reducer';
import SelectPathModal from '../Modals/Feed/SelectPathModal';
import { getFeedInfo, getPreviewWithoutAuth } from '../../../../../../slices/feeds/thunk';
import TargetUrlModal from '../Modals/Feed/TargetUrlModal';
import { getPublishList, openPublishPage, pushChanges } from '../../../../../../slices/publish/thunk';
import FontWarning from '../../../Components/FontWarning';
import FontModal from '../../../FontModal';
import DynamicVideoWarning from '../../../Components/DynamicVideoWarning';
import DuplicateNewSizeCreative from '../../../Components/Modals/DuplicateNewSizeCreative';
import { setFeedsHasMore, setPreview } from '../../../../../../slices/feeds/reducer';
import { toggleFacebookModal, toggleFigmaPluginModal } from '../../../../../../slices/modals/reducer';
import { putCreative } from '../../../../../../helpers/backend_helper';
import { toast } from 'react-toastify';
import { paginateArray } from '../../../../../../slices/helper';
import FacebookModal from '../Modals/FacebookModal';
import PublishSuccessModal from '../Modals/PublishSuccessModal';
import { publishFacebook, pushChangesSocial } from '../../../../../../slices/publish/facebook/thunk';
import FontBtn from '../../../Components/Buttons/FontBtn';
import { push, replace } from 'redux-first-history';
import { useParams } from 'react-router-dom';
import { setCreativesForPublish, setPublishList, setPublishLoader, setSelectedCreativesPublish, setSelectedPublishType, setWhereToPublish } from '../../../../../../slices/publish/reducer';
import { availabilityOption } from '../../../../../../common/facebook';
import PushChangesBtn from '../../../Components/Buttons/PushChangesBtn';
import UnPublishBtn from './UnPublishBtn';
function VersionPage() {
  const dispatch = useDispatch();
  const params = useParams();
  // Select All Versions
  const selectVersionsState = createSelector((state) => state, (state) => ({
    title: state.MenuData.title,
    versions: state.Campaign.versions,
    currentVersion: state.Campaign.currentVersion,
    uploadLimits: state.Upload.uploadLimits,
    dynamicText: state.Campaign.dynamicText,
    currentCampaign: state.Campaign.currentCampaign,
    previousLocations: state.router.previousLocations,
    facebookProperties: {
      _id: state.Campaign.facebookId,
      properties: {
        title: state.Campaign.title,
        description: state.Campaign.description,
        availability: state.Campaign.availability,
        condition: state.Campaign.condition,
        price: state.Campaign.price,
        link: state.Campaign.link,
        image_link: state.Campaign.image_link,
      },
      brandId: state.Campaign.brand,
      interval: state.Campaign.interval,
      exportType: 'image',
      limit: state.Campaign.limit,
    },
    facebookId: state.Campaign.facebookId,
    isFacebookPropertiesSet: state.Campaign.isFacebookPropertiesSet,
    language: state.MenuData.langauge,
    title: state.MenuData.title,
    dynamicText: state.Campaign.dynamicText,
    activeDynamicText: state.Campaign.activeDynamicText,
    selectedCreative: state.Campaign.selectedCreative,
    filteredFontList: state.Campaign.filteredFontList,
    currentCampaign: state.Campaign.currentCampaign,
    currentVersion: state.Campaign.currentVersion,
    connectedFeed: state.Campaign.connectedFeed,
    connectedFeedName: state.Campaign.connectedFeedName,
  }));
  const {
    versions,
    currentVersion,
    uploadLimits,
    dynamicText,
    currentCampaign,
    connectedFeed,
    connectedFeedName,
    previousLocations,
    facebookProperties,
    facebookId,
    isFacebookPropertiesSet,
    language,
    title,
    activeDynamicText,
    selectedCreative,
    filteredFontList
  } = useSelector(selectVersionsState);

  useEffect(() => {
    if (currentCampaign && currentVersion === null) {
      dispatch(openCampaign(currentCampaign));
    }
  }, [currentVersion]);

  // Select Creative State
  const selectCreativeState = createSelector((state) => state.Campaign, (state) => ({
    creatives: state.creatives,
    filteredCreatives: state.filteredCreatives,
    scrolledCreatives: state.scrolledCreatives,
    creativesPage: state.creativesPage,
    creativesHasMore: state.creativesHasMore,
    creativesLoading: state.creativesLoading,
    creativesFirstLoad: state.creativesFirstLoad,
  }));
  const {
    creatives,
    filteredCreatives,
    scrolledCreatives,
    creativesPage,
    creativesHasMore,
    creativesLoading,
    creativesFirstLoad
  } = useSelector(selectCreativeState);

  const bannerRowRef = useRef(null);
  const [scrolledCreativeState, setScrolledCreativeState] = useState([]);

  const loadCreative = useCallback(async (pageNum, creativeData, scrolledCreatives, itemsPerPage = 2) => {
    if (filteredCreatives) {
      dispatch(setCreativesLoading(true));
      try {
        const sortedArray = paginateArray(creativeData, pageNum, itemsPerPage);
        if (sortedArray) {
          if (scrolledCreatives.length > 0) {
            dispatch(setScrolledCreatives([...scrolledCreatives, ...sortedArray]));
            setScrolledCreativeState([...scrolledCreatives, ...sortedArray]);
          } else {
            dispatch(setScrolledCreatives([...sortedArray]));
            setScrolledCreativeState([...sortedArray]);
          }
        }
      } catch (error) {
        // console.log(error);
      } finally {
        dispatch(setCreativesLoading(false));
      }
    }
  }, []);

  useEffect(() => {
    async function handleFirstLoad() {
      if (creativesFirstLoad === true && Array.isArray(filteredCreatives) && filteredCreatives.length > 0) {
        const firstLoadCount = calculateCreativesPerPage(300);
        loadCreative(1, filteredCreatives, scrolledCreatives, firstLoadCount);
        dispatch(setCreativesPage((firstLoadCount / 2) + 1));
        dispatch(setCreativesFirstLoad(false));
      }
    }
    handleFirstLoad();
  }, [loadCreative, filteredCreatives, scrolledCreatives, creativesFirstLoad]);

  let scrollTimeout
  useEffect(() => {
    async function handleScroll() {
      if (scrollTimeout) clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(async () => {
        const scrollableHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const currentScroll = window.scrollY;

        if (currentScroll >= scrollableHeight - 50) {
          if (!creativesLoading && creativesHasMore) {
            await loadCreative(creativesPage, (filteredCreatives ? filteredCreatives : []), scrolledCreatives, 2);
            dispatch(setCreativesPage(creativesPage + 1));
            dispatch(setCreativesFirstLoad(false));
          }
        }
      }, 100);  
    }
    if (creativesFirstLoad === false) {
      window.addEventListener("scroll", handleScroll);
    }
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loadCreative, creativesFirstLoad, creativesHasMore, creativesLoading, creativesPage, scrolledCreatives]);

  async function updateCreativeState(figma, creativeId, scrolledCreatives) {
    dispatch(toggleFigmaPluginModal(false));
    dispatch(setCampaignLoader(true));
    const updatededCreatives = [];
    let mustBePutCreative = {};
    let i = 0;
    do {
      if (creatives[i]._id === creativeId) {
        mustBePutCreative = { ...creatives[i], figmaObject: figma, preview: false, isLoading: false };
        updatededCreatives.push(mustBePutCreative);
      } else {
        const foundCreative = scrolledCreatives.find(creative => creative._id === creatives[i]._id);
        if (foundCreative) {
          updatededCreatives.push(foundCreative);
        } else {
          updatededCreatives.push(creatives[i]);
        }
      }
      i++;
    } while (i < creatives.length);
    // dispatch(setCreatives(updatededCreatives));
    dispatch(updateCreatives(mustBePutCreative));
    dispatch(setFilteredCreatives(updatededCreatives));
    dispatch(updateScrolledCreatives(mustBePutCreative));
    // dispatch(setScrolledCreatives(updatededCreatives));
    setScrolledCreativeState(updatededCreatives);
    const res = await putCreative({ creativeArray: [mustBePutCreative], campaignId: currentCampaign._id });
    const {updatedVersion, updatedVersions} = await dispatch(updateVersionStatusAfterUpdate());
    let foundDynamicText = dynamicText[0];
    if (activeDynamicText && activeDynamicText.isCreative) {
      foundDynamicText = dynamicText.find(dItem => dItem.isCreative === true && dItem.creativeId === activeDynamicText.creativeId);
    }
    dispatch(setActiveDynamicText(null));
    setTimeout(() => {
      dispatch(setActiveDynamicText(foundDynamicText));
    }, 1);
    dispatch(replace(window.location.href, {
      versions: updatedVersions,
      currentCampaign: currentCampaign,
      currentVersion: updatedVersion,
      facebookProperties: facebookProperties,
      isFacebookPropertiesSet: isFacebookPropertiesSet,
      facebookId: facebookId,
      connectedFeed: connectedFeed,
      connectedFeedName: connectedFeedName,
      dynamicText: dynamicText,
      activeDynamicText: foundDynamicText,
      creatives: updatededCreatives.map((item) => {
        let returnObj = {};
        let keys = Object.keys(item);
        keys.forEach(key => {
          if (key !== 'preview') {
            returnObj[key] = item[key];
          }
        });
        return returnObj;
      }),
      fontRes: filteredFontList,
      uploadLimits: uploadLimits,
      title: title,
      campaignLoader: false,
    }))
    // dispatch(setCampaignLoader(false));
  };

  useEffect(() => {
    async function listenPlugin(event) {
      if (event?.data) {
        if (event.data?.action === 'adc-creative-edit') {
          const figma = JSON.parse(event.data.frames)[0];
          await updateCreativeState(figma.figma, figma.creativeId, scrolledCreatives);
        }
      }
    }
    window.addEventListener('message', listenPlugin);
    return () => {
      window.removeEventListener('message', listenPlugin);
    };
  }, [scrolledCreatives]);

  return (
    <React.Fragment>
      <Container fluid>
        <Row>
          <Card className='p-3 mb-3 d-flex flex-row flex-wrap align-items-center justify-content-between gap-2'>
            <div className='d-flex align-items-center gap-2'>
              <SwitchVersion />
              <SettingsButton />
              <NewVersionBtn />
              <DuplicateVersionBtn />
              <FeedBindBtn />
            </div>
            <div className='d-flex align-items-center gap-2'>
              <NewCreativeBtn />
              {/* <PublishBtn onClick={() => facebookPublish()} /> */}
              <PublishBtn onClick={() => dispatch(openPublishPage())} />
              {currentVersion?.published === 1 ?
                <PushChangesBtn onClick={() => dispatch(pushChangesSocial())} />
              : null}
              <UnPublishBtn />
            </div>
          </Card>
        </Row>
        <Row>
          <Card className='px-0 mb-3 w-100 d-flex flex-row flex-wrap gap-2 align-items-center justify-content-between bg-transparent border-0 shadow-none'>
            <div>
              <StatusBadge />
            </div>
            <div className='d-flex flex-wrap align-items-center gap-2'>
              <FontBtn />
              <CommentBtn />
              <ShowcaseBtn />
              <ApproveAllBtn />
              <Filters />
            </div>
          </Card>
          <DynamicVideoWarning />
          <FontWarning />
        </Row>
        <Row>
          <Col xxl={dynamicText !== null && dynamicText?.length > 0 ? 8 : 12} className='p-0'>
            <div className='row' ref={bannerRowRef}>
              {(scrolledCreatives || []).length > 0 ?
                scrolledCreatives.map((item, idx) => {
                  if (item) {
                    return (
                      <Col xxl={dynamicText !== null && dynamicText.length > 0 ? 6 : 4} key={idx}>
                        <BannerCard idx={idx}
                          id={item._id}
                          figma={item.figma}
                          figmaObject={item?.figmaObject}
                          type={'html'}
                          size={item.size}
                          comments={item.comments}
                          approvement={item.approvement}
                          published={item.published}
                          previewProp={item?.preview}
                          showEdit={true}
                          editableInFigmaPlugin={true}
                          isCreativeCreated={true}
                          updateStateAfterLoad={true}
                          isBannerLoadingProp={item?.isLoading} />
                      </Col>
                    )
                  }
                })
                : null}
            </div>
          </Col>
          {dynamicText !== null && dynamicText?.length > 0 ?
            <Col xxl={4} className='p-0 ps-3'>
              <DynamicEditArea />
            </Col>
            : null}
        </Row>
      </Container>
      <DuplicateSetModal />
      <DuplicateNewSizeCreative />
      <SettingsModal />
      <AddNewTemplateCreative dropFileType={uploadLimits?.find(item => item.type === "html")} />
      <AddNewTemplateVersion dropFileType={uploadLimits?.find(item => item.type === "html")} />
      <SelectTemplateModal />
      <FilterModal />
      <Comment />
      <ShowcaseModal />
      <FallbackImageModal />
      <FeedConnection />
      <SelectPathModal />
      <FacebookModal />
      <PublishSuccessModal />
      <TargetUrlModal />
      <FontModal />
    </React.Fragment>
  )
}

export default VersionPage
